import React from 'react';
import { useTranslation } from 'react-i18next';
import { BD } from '../bookDemoTheme';
import { STEP_ORDER } from '../types';

interface ProgressStepsProps {
  /** 1-based index into STEP_ORDER. */
  currentStep: number;
}

const ProgressSteps: React.FC<ProgressStepsProps> = ({ currentStep }) => {
  const { t } = useTranslation();
  const totalSteps = STEP_ORDER.length;

  return (
    <div className="px-4 sm:px-6 lg:px-12 mb-8 sm:mb-10">
      <p className={`text-[20px] sm:text-[24px] leading-6 sm:leading-[30px] font-semibold mb-4 ${BD.textPrimary}`}>
        {t('bookDemo.progress.stepOf', { current: currentStep, total: totalSteps })}
      </p>
      <div className="grid grid-cols-4 sm:grid-cols-7 gap-3 sm:gap-4">
        {STEP_ORDER.map((step, index) => {
          const isActive = index + 1 <= currentStep;
          return (
            <div key={step} className="min-w-0">
              <p
                className={`text-[12px] sm:text-[14px] leading-6 font-normal uppercase mb-2 sm:mb-4 truncate ${
                  isActive ? BD.accentTextDeep : BD.textSecondary
                }`}
              >
                {t(`bookDemo.progress.labels.${step}`)}
              </p>
              <div className={`h-[7px] rounded-full ${isActive ? BD.accentBg : BD.trackIdle}`} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressSteps;
